document.addEventListener("DOMContentLoaded", () => {

  if (window.innerWidth <= 768) {
    return; // Disable swiper on mobile
  }

  new Swiper(".festive-slider", {
    slidesPerView: 4,
    spaceBetween: 25,

    navigation: {
      nextEl: ".festive-next",
      prevEl: ".festive-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

});